module.exports = __webpack_public_path__ + "media/images/icon/icons8-Process-bf123512f345a076933f93c519e9d3af.png";